import { colors, fonts } from '../../theme';

const mobileBar = {
  height: 48,
  display: 'flex',
  justifyContent: 'center',
  border: 0,
  backgroundColor: colors.surface,
};

const styles = {
  // Mobile (read only): compact bar, the logo and one button to open the app.
  mobileBar,
  // Over the video: dark and blurred, the video stays visible.
  mobileFeedBar: {
    ...mobileBar,
    backgroundColor: 'rgba(0, 0, 0, 0.65)',
    backdropFilter: 'blur(8px)',
  },
  mobileToolbar: {
    minHeight: 48,
    pl: '14px',
    pr: '12px',
  },
  mobileIconButton: {
    p: 0,
    mr: 1,
    color: colors.text,
  },
  mobileLogo: {
    height: '24px',
  },
  mobileTitle: {
    flexGrow: 1,
    cursor: 'pointer',
    fontFamily: fonts.display,
    fontWeight: 700,
    fontSize: 24,
    lineHeight: 1,
    letterSpacing: '0.5px',
  },
  mobileOpenApp: {
    height: 34,
    minWidth: 0,
    px: 1.5,
    borderRadius: '9px',
    backgroundColor: colors.text,
    color: colors.background,
    fontFamily: fonts.text,
    fontSize: 13,
    fontWeight: 600,
    textTransform: 'none',
    whiteSpace: 'nowrap',
    '&:hover': {
      backgroundColor: colors.text,
    },
  },
};

export default styles;
